jQuery( document ).ready( function( $ ) {

  // Close mini cart
  $( '.mini-cart__bg, .mini-cart__content .close' ).on( 'click', function(){
    closeMini();
  } );

  // Show mini cart
  $( '.header .icon--cart' ).on( 'click', function( e ){
    e.preventDefault();

    if ( ! $( 'body' ).hasClass( 'template__cart' ) ) {
      showMini();
    } else {
      e.preventDefault();
    }
  } );

  // Mini Cart Remove Product
  $( '.mini-cart' ).on( 'click', '.remove-product', function(  ) {
    var lineNum = $( this ).closest( '.product' ).attr( 'data-lineid' );
    $( this ).closest( '.product' ).addClass( 'removed' );

    CartJS.removeItem( lineNum, {
      success: function(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function(cart) {
          refreshMiniCart(cart);
        });
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.log( errorThrown );
      }
    } )
  });

    // Mini Cart Upsell ATC
  $( '.mini-cart__upsell .action--atc' ).on( 'click', function( e ) {
    e.preventDefault();

    var dataId = $( this ).closest( '.upsell' ).attr( 'data-id' );

    CartJS.addItem( dataId, 1, {}, {
      success: function(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function(cart) {
          refreshMiniCart(cart);
        });
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.log( errorThrown );
      }
    } )
  } )

  // Mini Cart Qty
  $('.mini-cart__list').on('click', '.js-qty--mini', function(e) {
    e.preventDefault();

    var $this = $(this);
    var $parent = $this.parent();
    var qtyInput = $parent.find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;
    var lineData = $this.closest('.product').data('lineid');
    var lineNum = $('[data-lineID="' + lineData + '"]').index();

    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    }

    CartJS.updateItem((lineNum + 1), qtyInputVal, {}, {
      success: function(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function(cart) {
          refreshMiniCart(cart);
        });
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.log( errorThrown );
      },
    });
  });

	// Allow typing of input qty for update
	var timer;
	$( '.mini-cart__list' ).on( 'keyup', '.actions .qty-val', function () {
		var $this = $(this);
    var newVal = $this.val();
		var lineData = $this.closest('.product').data('lineid');

		// clear the previous timer
		clearTimeout(timer);

		// create a new timer with a delay of 300ms seconds,
		// if the keyup is fired before the 300ms secs then the timer will be cleared
		timer = setTimeout(function () {
			// this will be executed if there is a gap of 300ms seconds between 2 keyup events
			console.log(newVal);
			CartJS.updateItem(lineData, newVal, {}, {
				success: function(data, textStatus, jqXHR) {
					jQuery.getJSON('/cart.js', function(cart) {
						refreshMiniCart(cart);
					});
				},
				error: function(jqXHR, textStatus, errorThrown) {
					console.log( errorThrown );
				},
			});
		}, 300);
	});
});

function closeMini () {
  $( 'body' ).removeClass( 'cart-open' );
  $( '.mini-cart' ).removeClass( 'is-open' );
  $( '.mini-cart' ).fadeOut( 'fast' );
}

function showMini () {
  $( 'body' ).addClass( 'cart-open' );
  $( '.mini-cart' ).fadeIn( 'fast' );
  $( '.mini-cart' ).addClass( 'is-open' );


  // Set height of product list for full-height mini-cart
  // var miniHead = parseInt( $( '.mini-cart__header' ).innerHeight() );
  // var miniShip = parseInt( $( '.mini-cart__ship' ).innerHeight() );
  // var miniFooter = parseInt( $( '.mini-cart__footer' ).innerHeight() );
  // var miniUp = parseInt( $( '.mini-cart__upsell' ).innerHeight() );
  // var miniTotalHeight = miniHead + miniShip + miniFooter + miniUp;
}

function refreshMiniCart(cartData) {
  var cartItems = cartData.items;
  var newCartHtml = '';

  // Free shipping updater
  var totalShip = parseInt( $( '.mini-cart' ).data( 'freeship' ) );
  var newCartTotal = cartData.items_subtotal_price;
  var awayShip = totalShip - newCartTotal;
  var shipPercent = ( newCartTotal / totalShip ) * 100;

  if ( shipPercent >= 100 ) {
    $( '.shipping-bar--progress' ).css( 'width', '100%' );
    $( '.mini-cart__ship' ).addClass( 'is-free' );
  } else {
    if ( $( '.mini-cart__ship' ).hasClass( 'is-free' ) ) {
      $( '.mini-cart__ship' ).removeClass( 'is-free' )
    }
    $( '.free-count' ).text( formatter.format( awayShip / 100) );
    $( '.shipping-bar--progress' ).css( 'width', shipPercent+'%' );
  }

	// If cart is now empty
	if ( cartData.item_count == 0 ) {
    newCartHtml += ' <h3 class="text-center">Cart is empty</h3>';
  } else {

		// Build html of new products in cart
		$.each(cartItems, function(index, item) {
			// Opening
			newCartHtml += '<div class="product product--cart d-flex justify-between" data-lineid="'+( index + 1 )+'">';

				newCartHtml += ' <div class="product__image">';
					if (  item.featured_image ) {
						newCartHtml += '<a href="' + item.url + '">';
							newCartHtml += '<img src="' + item.featured_image.url.replace('.jpg', '_80x.jpg').replace( '.png', '_80x.png' ) + '" srcset="' + item.featured_image.url.replace('.jpg', '_160x.jpg').replace( '.png', '_160x.png' ) + ' 2x" alt="' + item.image.alt +'">';
						newCartHtml += '</a>';
					}
				newCartHtml += '</div>';
				newCartHtml += '<div class="product__info">';
					newCartHtml += '<div class="title d-flex">';
						newCartHtml += '<h3 class="heading--four d-flex justify-between">'
							newCartHtml += '<a class="no-dec trans" href="' + item.url + '">';
								newCartHtml += item.product_title;
							newCartHtml += '</a>';
							newCartHtml += ' <button class="remove-product trans"><span class="sr-only">Remove</span><img src="//cdn.shopify.com/s/files/1/0506/7037/0997/t/2/assets/icon-close.svg?v=18585775398919142161649090024" alt="" /></button>';
						newCartHtml += '</h3>'
						if ( item.options_with_values != null && item.options_with_values[0].name != 'Title' ) {

									$.each( item.options_with_values, function( index, value ) {
										console.log( 'index:'+index );
										console.log( 'value:'+value );
										newCartHtml += '<div class="var">';
											newCartHtml += '<span>'+item.options_with_values[index].name+': '+item.options_with_values[index].value+'</span>';
										newCartHtml += '</div>';
									} );

							}
						if ( item.hasOwnProperty( 'selling_plan_allocation' ) ) {
							newCartHtml += '<span class="delivery">'+ item.selling_plan_allocation.selling_plan.name +'</span>';
						}
						newCartHtml += '<span class="unit-price">'+formatter.format(item.price / 100)+'</span>';
					newCartHtml += '</div>';
					// newCartHtml += '<div class="price">'+formatter.format(item.final_line_price / 100)+'</div>';
					newCartHtml += `<div class="actions d-flex align-center justify-between">
						<div class="action action--qty">
							<div class="qty d-flex align-center">
								<button class="js-qty js-qty--mini js-qty--minus trans">
									<span class="sr-only">Decrease</span>
								</button>
								<input sm-rc-quantity-selector type="text" value="` + item.quantity + `" min="1"  type="number" class="qty-val" />
								<button class="js-qty js-qty--mini js-qty--plus trans">
									<span class="sr-only">Increase</span>
								</button>
							</div>
						</div>`;
						newCartHtml += '<div class="price">'+formatter.format(item.final_line_price / 100)+'</div>'
					newCartHtml += '</div>';

				// Closing
				newCartHtml += '</div>';
			newCartHtml += '</div>';
		});
	}

  // Clear current products in cart
  $('.mini-cart__items').empty();

  // Set new subtotal
  $('.mini-cart__footer .sub-total .total').text(formatter.format(cartData.total_price / 100));

  // Set new header icon count
  $('.icon--cart .cart-count span ').text(cartData.item_count);

  // Add updated producst to mini cart
  $('.mini-cart__list').html(newCartHtml);

  // Show mini cart
  showMini();
}
